import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '../../../store';
import { continueApplicationProcessing } from '../../application/reducers/application';

type IsSubaccountState = {
  isSubaccount: boolean;
};

const initialState: IsSubaccountState = {
  isSubaccount: false,
};

const slice = createSlice({
  name: 'isSubaccount',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(
      continueApplicationProcessing,
      (
        state,
        {
          payload: {
            response: { isSubaccount },
          },
        },
      ) => {
        return { ...state, isSubaccount: isSubaccount ?? false };
      },
    );
  },
});

export const isSubaccountReducer = slice.reducer;

export const selectIsSubaccount = (state: RootState) => state.isSubaccount;
